import React, { useEffect, useState }                                                                         from 'react';
import { Group, Stack, Text, UnstyledButton }                                                                 from '@mantine/core';
import { RangeCalendar }                                                                                      from '@mantine/dates';
import { IconX }                                                                                              from '@tabler/icons';
import { disablePastAndControlledDates, formatBookingCardRangeDate, getBlockedDatesFromCalendar, matchDates } from '@utils/date-utils';
import { useClickOutside }                                                                                    from '@mantine/hooks';
import { CIconButton }                                                                                        from '@core/components/common/CIconButton';
import useIsMounted                                                                                           from '@hooks/use-is-mounted';
import { useBookingState }                                                                                    from "@core/providers/BookingStateProvider";
import { usePropertyState }                                                                                   from "@core/providers/PropertyStateProvider";

import { RecordStatus }                                                                                       from '../../../../generated/graphql';
import useStyles                                                                                              from './BookingRangeSelector.styles';

export const BookingRangeSelector: React.FC = () => {

    const { classes } = useStyles();
    const isMounted = useIsMounted();

    const {
        propertyCalendarPrices,
        setSelectedBookingRange,
        bookingInfo,
        selectedDates,
        setSelectedDates,
        calculatePricesAndStore,
        resetPrices,
    } = useBookingState();

    const { propertyDetailsData } = usePropertyState();

    const [isClearVisible, setIsClearVisible] = useState(false)
    const [isRangeVisible, setIsRangeVisible] = useState(false)

    // GOOD BOY
    const ref = useClickOutside(() => {
        setIsRangeVisible(false)
    });

    useEffect(() => {

        if (bookingInfo) {

            setSelectedDates(selectedDates);

            if (bookingInfo.start_date !== '') {
                setIsClearVisible(true);
            }

        }

    }, [bookingInfo]);

    // RESET LOCAL STATE ONLY
    function cleanup() {

        setSelectedBookingRange([null, null]);

        setSelectedDates([null, null]);

        resetPrices();
    }

    return isMounted && (
        <Group className={classes.checkWrapper}>

            {
                selectedDates !== null &&
                <UnstyledButton
                    className={classes.checkInMain}
                    onClick={() => {
                        setIsRangeVisible(true);

                        // RESETTING WHEN SELECTING RANGE
                        setIsClearVisible(false)
                        cleanup();
                    }}
                >
                    <Stack>
                        <Text className={classes.checkLabel}>Check in</Text>
                        <Text className={classes.checkDescription}>When will your arrive?</Text>
                        <Text className={classes.checkInput}>{formatBookingCardRangeDate(selectedDates[0], 'Add date')}</Text>
                    </Stack>
                </UnstyledButton>

            }

            {
                selectedDates !== null &&
                <UnstyledButton
                    className={classes.checkOutMain}
                    onClick={() => {
                        setIsRangeVisible(true)

                        // RESETTING WHEN SELECTING RANGE
                        setIsClearVisible(false)
                        cleanup();
                    }}
                >
                    <Stack>
                        <Text className={classes.checkLabel}>Check out</Text>
                        <Text className={classes.checkDescription}>When do you plan to leave?</Text>
                        <Text className={classes.checkInput}>{formatBookingCardRangeDate(selectedDates[1], 'Add date')}</Text>
                    </Stack>
                </UnstyledButton>
            }

            {
                isClearVisible &&
                <CIconButton
                    className={classes.checkClearIcon}
                    label="Clear calendar dates"
                    onClick={() => {
                        setIsClearVisible(false)
                        cleanup();
                    }}
                    light={<IconX color="orange" size={24}/>}
                    dark={<IconX color="orange" size={24}/>}
                    props={{
                        variant: 'light',
                        p: 20,
                        mt: 20,
                    }}
                />
            }

            <Stack className={classes.calStack}>
                {
                    isRangeVisible &&
                    <RangeCalendar
                        className={classes.calendarBase}
                        ref={ref}
                        value={selectedDates}
                        onChange={(range) => {

                            // FOR BOOKING INFO
                            setSelectedBookingRange(range)

                            // DON'T ALLOW SAME RANGE AGAIN -
                            // CURRENTLY NOT NECESSARY BUT STILL FOR THE EDGE CASES
                            // WE WILL MATCH THE DATES.
                            if (!matchDates(range, selectedDates)) {

                                // LOCAL STATE
                                setSelectedDates([...range]);

                                // LOCAL STATE
                                calculatePricesAndStore(range)

                                if (range[1] !== null) {
                                    setIsRangeVisible(false);
                                    setIsClearVisible(true);
                                    //onRangeSelection(range);
                                }
                            }

                        }}
                        excludeDate={(date) => {

                            if (propertyDetailsData.settings?.calendarState === RecordStatus.Disabled) {
                                return true;
                            } else {
                                return disablePastAndControlledDates(date, getBlockedDatesFromCalendar(propertyCalendarPrices.smoobu))
                            }

                        }}
                        sx={classes}
                        firstDayOfWeek="monday"
                        weekendDays={[0]}
                        allowLevelChange={false}
                        disableOutsideEvents={false}
                        amountOfMonths={1}
                        // size="md"
                    />
                }
            </Stack>


        </Group>
    )

}
